<app-mm></app-mm>

<router-outlet></router-outlet>

<app-cookies></app-cookies>
<app-hint></app-hint>
<app-cart></app-cart>

<app-loading></app-loading>
